import React, { useState, useEffect, useRef } from "react";
import { useMediaQuery } from "@mui/material";

const DigitalAssets = () => {
  const [count, setCount] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  const [fade, setFade] = useState(false);
  const [hasCounted, setHasCounted] = useState(false);
  const sectionRef = useRef(null);

  // Check if the screen is mobile-sized
  const isMobile = useMediaQuery('(max-width: 767px)');

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !hasCounted) {
            setIsVisible(true);
            setCount(0);
            setFade(false);
          }
        });
      },
      { threshold: 0.5 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, [hasCounted]);

  useEffect(() => {
    if (isVisible && !hasCounted) {
      let start = 0;
      const end = 8;
      const duration = 3000;
      const incrementTime = Math.floor(duration / end);

      const counter = setInterval(() => {
        start += 1;
        setCount(start);
        if (start === end) {
          clearInterval(counter);
          setFade(true);
          setHasCounted(true);
        }
      }, incrementTime);

      return () => clearInterval(counter);
    }
  }, [isVisible, hasCounted]);

  const styles = {
    container: {
      display: "flex",
      flexDirection: isMobile ? "column" : "row",
      justifyContent: isMobile ? "center" : "space-between",
      alignItems: isMobile ? "center" : "center",
      padding: isMobile ? "10px 30px" : "20px",
      marginTop: isMobile ? "60px" : "120px",
      backgroundColor: "#E7E4E2",
      maxWidth: "1300px",
      marginLeft: "auto",
      marginRight: "auto",
      textAlign: isMobile ? "center" : "left",
    },
    text: {
      fontSize: isMobile ? "30px" : "40px",
      background: "linear-gradient(90deg, #2D669B 0%, #0582CA 100%)",
      WebkitBackgroundClip: "text",
      backgroundClip: "text",
      color: "transparent",
      fontWeight: "bold",
      width: isMobile ? "auto" : "654px"
    },
    numberContainer: {
      display: "flex",
      flexDirection: "column",
      alignItems: isMobile ? "center" : "flex-start",
      marginTop: isMobile ? "10px" : "0",
    },
    numberRow: {
      display: "flex",
      flexDirection: "row",
      alignItems: "flex-start",
      maxHeight: isMobile ? "50px" : "70px",
    },
    number: {
      fontSize: isMobile ? "2.5rem" : "4rem",
      color: "#0582CA",
      fontWeight: "bold",
    },
    plusText: {
      fontSize: isMobile ? "2.5rem" : "4rem",
      color: "#0582CA",
      fontWeight: "bold",
      marginLeft: "5px",
      alignSelf: "flex-start",
    },
    descriptionContainer: {
      marginTop: "10px",
      textAlign: "left",
      marginLeft: isMobile ? "0px" : "3px",
      opacity: fade ? 1 : 0,
      transform: fade ? "translateX(0)" : "translateX(-20px)",
      transition: "opacity 1s ease, transform 1s ease",
    },
    description: {
      fontSize: isMobile ? "16px" : "20px",
      color: "#919191",
      textAlign: isMobile ? "center" : "left",
      marginLeft: isMobile ? "0" : "3px",
    },
  };

  return (
    <div style={styles.container} ref={sectionRef}>
      <div>
        <h2 style={styles.text}>
          We support a wide range of digital assets across

          over 8 blockchain networks
        </h2>
      </div>
      <div style={styles.numberContainer}>
        <div style={styles.numberRow}>
          <span style={styles.number}>{count}</span>
          <span style={styles.plusText}>+</span>
        </div>
        <div style={styles.descriptionContainer}>
          <p style={styles.description}>Networks</p>
        </div>
      </div>
    </div>
  );
};

export default DigitalAssets;
